package ysdk

import kotlinx.coroutines.*

actual suspend fun getYaSdk(): YaSdk? {
    return yaGames.init().await()
}

actual external interface YaSdk {
    actual val adv: YaAdv
    actual val deviceInfo: DeviceInfo
    actual val environment: YaEnvironment
}

actual external interface YaAdv {
    actual fun showFullscreenAdv()
}


actual fun printJson(source: Any?) {
    console.log(JSON.stringify(source))
}

actual external interface DeviceInfo {
    actual fun isMobile(): Boolean
    actual fun isDesktop(): Boolean
    actual fun isTablet(): Boolean
    actual fun isTV(): Boolean
}

actual interface YaPLayer {

}

actual external interface YaEnvironment {
    actual val i18n: Yai18n
}

actual external interface Yai18n {
    actual val lang: String
    actual val tld: String
}
